var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FFC817"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 24.5H45M27 47.5H45M29.5 47.5V41.5L32.356 39.786C33.0098 39.3938 33.5509 38.8389 33.9266 38.1754C34.3023 37.5119 34.4998 36.7625 34.4998 36C34.4998 35.2375 34.3023 34.4881 33.9266 33.8246C33.5509 33.1611 33.0098 32.6062 32.356 32.214L29.5 30.5V24.5M42.5 24.5V30.5L39.644 32.214C38.9904 32.6064 38.4495 33.1614 38.074 33.8248C37.6985 34.4883 37.5012 35.2376 37.5012 36C37.5012 36.7624 37.6985 37.5117 38.074 38.1752C38.4495 38.8386 38.9904 39.3936 39.644 39.786L42.5 41.5V47.5",
    stroke: "#FFC817",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.c3e2b336f529c1bca965c78faf2237e3.svg";
export { ForwardRef as ReactComponent };